//Call_[npm_run_updateTestIndexes]_to_update_this_file.

// @create-index

module.exports = {
    SummaryDetailLayout: require('./SummaryDetailLayout'),
    TabViewLayout: require('./TabViewLayout'),
};


